// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-heading{
    color:#002C57;
    font-weight: 500;
    font-size:20px ;
    margin-top: 20px;
}

.theading-body{
    margin-top: 20px;
    margin-bottom: 20px;
    display:flex;
    justify-content: space-between;
    padding: 10px;
    
}

.table-row-even{
color:1C1C1C !important;
font-weight: 500;
font-size: 16px;
background-color: #F2F2F2 !important;
}

.table-row-odd{
    color:1C1C1C !important;
    font-weight: 500;
    font-size: 16px;
}

.ant-table-thead th{
    font-weight: 500 !important;
    font-size: 12px !important;
    color: #767676 !important;
}

.custom-divider{
    background-color: #767676 !important;
    /* width: 2px !important; */
}

.heading-card{
    margin-top: 32px;
    display: flex;
    gap:35px;
    background-color: #F2F2F2 !important;
    padding-top: 6px;
    padding-bottom: 8px;
    padding-left: 14px;
    width: 100%;
    margin-bottom: 20px;
}

.heading-card .default-button{
    color: #767676;
    font-size: 14px;
    font-weight: 400;
    font-family: Ubuntu, sans-serif;
    margin-top: 10px;

}

.custom-dropdown{
    padding-top: 11px !important;
    padding-bottom: 11px !important;
    height: 90%;
    border-radius: 4px;
    border: none;
    width: 197px;
    height: 38px;
}
.custom-dropdown-button{
    display: flex !important;
    justify-content: space-between;
    width: 100%;
}

.ant-btn-color-default{
    color: #F16622 !important;
    font-weight: 500;
    font-size: 14px;
}


.primary-button{
    color: #F16622 ;
    border: 1px solid #F16622;
    border-radius: 50px;
    padding-left: 19px;
    padding-right: 19px;
    padding-top: 8.5px;
    padding-bottom: 8.5px;
    font-weight: 500;
    background-color: #FFFFFF;
}

.add-button{
    color: #F16622 ;
    font-size: 20px;
    border: 1px solid #F16622;
    border-radius: 50px;
    padding-left: 31px;
    padding-right: 31px;
    padding-top: 8.5px;
    padding-bottom: 8.5px;
    font-weight: 500;
    background-color: #FFFFFF;
}

.ant-pagination-item-active{
    background-color: #F16622 !important;
    color:white !important;
}

.ant-pagination-item-active a{
    color:white !important;
}

.ant-pagination-item{
    border: 1px solid #F16622 !important;
    color: #F16622 !important;
}`, "",{"version":3,"sources":["webpack://./src/views/DataAdministration/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;IAC9B,aAAa;;AAEjB;;AAEA;AACA,uBAAuB;AACvB,gBAAgB;AAChB,eAAe;AACf,oCAAoC;AACpC;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,QAAQ;IACR,oCAAoC;IACpC,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;;AAEpB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B","sourcesContent":[".table-heading{\n    color:#002C57;\n    font-weight: 500;\n    font-size:20px ;\n    margin-top: 20px;\n}\n\n.theading-body{\n    margin-top: 20px;\n    margin-bottom: 20px;\n    display:flex;\n    justify-content: space-between;\n    padding: 10px;\n    \n}\n\n.table-row-even{\ncolor:1C1C1C !important;\nfont-weight: 500;\nfont-size: 16px;\nbackground-color: #F2F2F2 !important;\n}\n\n.table-row-odd{\n    color:1C1C1C !important;\n    font-weight: 500;\n    font-size: 16px;\n}\n\n.ant-table-thead th{\n    font-weight: 500 !important;\n    font-size: 12px !important;\n    color: #767676 !important;\n}\n\n.custom-divider{\n    background-color: #767676 !important;\n    /* width: 2px !important; */\n}\n\n.heading-card{\n    margin-top: 32px;\n    display: flex;\n    gap:35px;\n    background-color: #F2F2F2 !important;\n    padding-top: 6px;\n    padding-bottom: 8px;\n    padding-left: 14px;\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.heading-card .default-button{\n    color: #767676;\n    font-size: 14px;\n    font-weight: 400;\n    font-family: Ubuntu, sans-serif;\n    margin-top: 10px;\n\n}\n\n.custom-dropdown{\n    padding-top: 11px !important;\n    padding-bottom: 11px !important;\n    height: 90%;\n    border-radius: 4px;\n    border: none;\n    width: 197px;\n    height: 38px;\n}\n.custom-dropdown-button{\n    display: flex !important;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.ant-btn-color-default{\n    color: #F16622 !important;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n\n.primary-button{\n    color: #F16622 ;\n    border: 1px solid #F16622;\n    border-radius: 50px;\n    padding-left: 19px;\n    padding-right: 19px;\n    padding-top: 8.5px;\n    padding-bottom: 8.5px;\n    font-weight: 500;\n    background-color: #FFFFFF;\n}\n\n.add-button{\n    color: #F16622 ;\n    font-size: 20px;\n    border: 1px solid #F16622;\n    border-radius: 50px;\n    padding-left: 31px;\n    padding-right: 31px;\n    padding-top: 8.5px;\n    padding-bottom: 8.5px;\n    font-weight: 500;\n    background-color: #FFFFFF;\n}\n\n.ant-pagination-item-active{\n    background-color: #F16622 !important;\n    color:white !important;\n}\n\n.ant-pagination-item-active a{\n    color:white !important;\n}\n\n.ant-pagination-item{\n    border: 1px solid #F16622 !important;\n    color: #F16622 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
